import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import LiveHeaderTitle from './live-header-title';

class LiveHeaderComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.render();
    }

    destroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        if (this.refs.title) {
            ReactDOM.render(
                <Provider store={store}>
                    <LiveHeaderTitle />
                </Provider>,
                this.refs.title
            );
        }
    }
}

export default LiveHeaderComponent;
